module.exports = __webpack_public_path__ + "static/media/2.121dec27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/cats/2.jpg
// module id = 207
// module chunks = 0